'use client';

import { usePathname } from 'next/navigation';
import { type FC } from 'react';

const FooterCopyright: FC = () => {
  const pathname = usePathname();

  const isHCP = pathname.includes('hcp');

  return (
    <div className="flex flex-col lg:flex-row lg:gap-x-2">
      <p>©2025 Organogenesis Inc. {!isHCP ? 'OI-AWCP-0044' : 'OI-AWCP-0132'}</p>
      <p>{isHCP ? '11/2025' : '01/2025'}</p>
    </div>
  );
};

export { FooterCopyright };
